module.exports = __webpack_public_path__ + "img/button-selected.2e97904c.png";